import React from 'react';
import {Box, Button, Card, Typography} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import {ConditionGroup, ConditionNode} from '../headerAnalysisRuleModel';
import {ConditionBuilder} from './ConditionBuilder/ConditionBuilder';
import {
  cardHeadingSx,
  validationErrorColor,
  validationErrorTextSx,
} from './headerAnalysisRulePresentation';

interface TriggerConditionsCardProps {
  tree: ConditionGroup;
  emptyConditionsError?: string;
  duplicateConditionGroupsError?: string;
  conditionErrors: Record<string, string>;
  onOperator: (groupId: string, operator: 'all' | 'any') => void;
  onAddGroupCondition: (groupId: string) => void;
  onAddGroup: () => void;
  onDetail: (condition: ConditionNode) => void;
  onRemove: (conditionId: string) => void;
}

export const TriggerConditionsCard: React.FC<TriggerConditionsCardProps> = ({
  tree,
  emptyConditionsError,
  duplicateConditionGroupsError,
  conditionErrors,
  onOperator,
  onAddGroupCondition,
  onAddGroup,
  onDetail,
  onRemove,
}) => (
  <Card
    data-testid="trigger-conditions-card"
    variant="outlined"
    sx={{p: 3, height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', minHeight: 0}}
  >
    <Typography className="authentication-checks-header rule-card-heading" sx={{...cardHeadingSx, mb: 3}}>Trigger Conditions</Typography>
    {tree.children.length ? (
      <Box sx={{flex: 1, minHeight: 0, overflow: 'auto'}}>
        <ConditionBuilder
          group={tree}
          conditionErrors={conditionErrors}
          highlightDuplicateGroups={Boolean(duplicateConditionGroupsError)}
          onOperator={onOperator}
          onAddGroupCondition={onAddGroupCondition}
          onAddGroup={onAddGroup}
          onDetail={onDetail}
          onRemove={onRemove}
        />
      </Box>
    ) : (
      <Box
        className="authentication-checks-empty-state"
        aria-invalid={Boolean(emptyConditionsError)}
        sx={{
          border: 1,
          borderColor: emptyConditionsError ? validationErrorColor : 'divider',
          bgcolor: 'grey.200',
          p: 5,
          py: {xs: 10, md: 5},
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          minHeight: 0,
        }}
      >
        <Typography color="text.secondary" mb={3}>No Condition Checks yet. Add one to get started.</Typography>
        <Button variant="contained" startIcon={<AddIcon/>} onClick={onAddGroup}>Add Condition</Button>
      </Box>
    )}
    {emptyConditionsError && (
      <Typography sx={{...validationErrorTextSx, mt: 1}}>
        {emptyConditionsError}
      </Typography>
    )}
  </Card>
);
